export function Button({ classes = '', text, ...props }) {
  classes = 'button ' + classes

  return (
    <div className={classes} {...props}>
      {text}
    </div>
  )
}
